<mat-nav-list>
  <a mat-list-item [routerLink]="['/payment-methods']">Payment Accounts</a>
  <hr/>
  <a mat-list-item [routerLink]="['/auto-pay']">AutoPay</a>
</mat-nav-list>
